import { Column, Row, Text } from "@/components";

// Separates the current job's calls from calls made for the candidate's other jobs.
export const OtherJobsDivider = () => {
  return (
    <Row className="items-center gap-3">
      <Column className="h-px flex-1 bg-slate-200" />
      <Text className="shrink-0 text-xs font-medium uppercase tracking-wider text-slate-400">
        Other jobs
      </Text>
      <Column className="h-px flex-1 bg-slate-200" />
    </Row>
  );
};
